<template>
  <div class="workorder-specific-info-card">
    <tabs
      :tabs="tabs"
      :active-tab="activeTab"
      :tabs-styling="tabsStyling"
      :tabs-labels-styling="tabsLabelsStyling"
      :center-tabs="false"
      @startTabChange="activeTab = $event"
    />
    <div :style="{'height': '100%', 'padding-top': '17px', 'overflow-y': 'auto', 'overflow-x': 'hidden' }">
      <management-map v-show="activeTab === 0" :style="{ 'height': 'calc(100% - 50px)'}" />
      <Table
        v-show="activeTab === 1"
        :tableLines="true"
        :checkbox="false"
        :loading="false"
        :headers="headers"
        :items="workorderObjects"
        :sortable="false"
        :emitRowClickBusEvent="false"
      />
    </div>
  </div>
</template>

<script>
import ManagementMap from "@/newComponents/_Molecules/ManagementMap.vue";
import Tabs from '@/newComponents/_Atoms/Tabs.vue';
import Table from "@/newComponents/_Molecules/Table.vue";
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import { bus } from '@/main.js';

export default {
  name: "WorkorderSpecificInfo",

  components: {
    ManagementMap,
    Tabs,
    Table,
  },

  props: {
    workorderGeom: {
      type: String,
      required: true,
    },

    workorderObjects: {
      type: Array,
    },
  },

  mixins: [activitiesTasksDataMixin],

  data() {
    return {
      activeTab: 0,
      tabsStyling: {
        'margin': '0px 0px 8px 0px',
        'width': '100%',
        'height': '39px',
      },
      tabsLabelsStyling: {
        'text-transform': 'none',
        'font-size': '10px',
        'letter-spacing': '0',
      },
    }
  },

  watch: {
    workorderGeom(value) {
      bus.$emit('draw-features', [value])
    },

    activeTab(value) {
      if (value === 0) {
        bus.$emit('draw-features', [this.workorderGeom]);
      }
    }
  },

  computed: {
    tabs() {
      return [
        { id: 'map', label: this.$i18n.tc("Map", 1) },
        { id: 'associated_objects', label: this.$i18n.tc("AssociatedObject", 2) },
      ]
    },

    headers() {
      return [
        { text: this.$i18n.tc("Label", 1), varName: "label" },
        { text: this.$i18n.tc("Layer", 1), varName: "type", function: this.getObjectTypeLabel },
      ]
    }
  },
}
</script>

<style scoped>
.workorder-specific-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  background-color: #fff;
  border-radius: 8px;
  padding: 17px 21px;
  flex: 1;
  position: relative;
  height: auto;
  max-height: 72%;
}

.v-tabs >>> .v-tabs-bar {
  height: 39px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/TasksManagement/WorkorderSpecificInfo.vue